import flow from 'lodash/flow';
import withProps from '@atlassian/jira-common-with-props';
import CreateButton from '@atlassian/jira-create-dashboards-button/src';
import DashboardsDirectory from '@atlassian/jira-dashboards-main/src';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl';

import DashboardsPage from './view';

export default flow(injectIntl, withProps({ CreateButton, DashboardsDirectory }))(DashboardsPage);
